// @ts-ignore
import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { useTour } from "hooks/useTour";

import { ArrowWrap, Container } from "./styles";

type TourBallonProps = {
  title: string;
  content: string;
  position: {
    left?: string;
    right?: string;
    top?: string;
    bottom?: string;
    arrowPosition: string;
    arrowTop?: string;
    arrowLeft?: string;
    maxWidth: number | string | null;
    boxShadow?: boolean;
    transform?: string;
    width?: string;
  };
};

const TourBalloon: React.FC<TourBallonProps> = ({
  position,
  title,
  content,
}) => {
  const [showNext, setShowNext] = useState(false);
  const [showBack, setShowBack] = useState(false);

  const { setShowTour, setTourStep, tourStep, steps } = useTour();

  useEffect(() => {
    if (tourStep === 1) {
      setShowBack(false);
    }
    if (tourStep <= steps) {
      setShowNext(true);
      if (tourStep > 1) {
        setShowBack(true);
      }
      if (tourStep === steps) {
        setShowNext(false);
      }
    }
  }, [tourStep, steps]);

  const handleNext = useCallback(() => {
    if (steps > tourStep) {
      setTourStep(tourStep + 1);
    }
  }, [steps, tourStep, setTourStep]);

  const handleBack = useCallback(() => {
    if (tourStep > 1) {
      setTourStep(tourStep - 1);
    }
  }, [tourStep, setTourStep]);

  return (
    <Container position={position}>
      <>
        <div>
          <span
            aria-hidden="true"
            onClick={() => {
              setShowTour(false);
              setTourStep(1);
            }}
          >
            X
          </span>
        </div>
        <h5>{title}</h5>
        <span
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </>
      <ArrowWrap showBack={showBack}>
        {showBack && (
          <AiOutlineArrowLeft color="#000FFF" size={22} onClick={handleBack} />
        )}
        {showNext && (
          <AiOutlineArrowRight color="#000FFF" size={22} onClick={handleNext} />
        )}
      </ArrowWrap>
    </Container>
  );
};

export default TourBalloon;
